module.exports = __webpack_public_path__ + "8dbf05e652ea62f5b754fe5e18929377.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/games/dow_image_mobile.jpg
// module id = 504
// module chunks = 0